import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'lib/axios';

export const useCompanyCategories = (): UseQueryResult<any[]> => {
	return useQuery({
		queryKey: ['companyCategories'],
		queryFn: async() => {
			const { data: { companyCategories } } = await axios.get('/company-categories')
			return companyCategories;
		}
	});
};


